/**
 * Import Dependency
 */
import React from 'react'
import {
  Toast,
} from 'antd-mobile'
import { injectIntl } from 'react-intl'
// import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

/**
 * Declare Variable
 */
const withToast = (ToastComponent) => {
  class _Toast_ extends React.Component {
    componentDidMount = () => {
      const {
        toastType,
        duration,
        message,
        callback,
        // intl,
      } = this.props

      const _duration = duration
      const _message = message
      const _callback = callback

      switch (toastType) {
        case 'fail':
          this.renderFailToast(_message, _duration, _callback)
          break
        case 'success':
          this.renderSuccessToast(_message, _duration, _callback)
          break
        case 'normal':
          this.renderToast(_message, _duration, _callback)
          break
        default:
          break
      }
    }

    renderToast = (message, duration, callback) => {
      Toast.show(message, duration, callback)
    }

    renderSuccessToast = (message, duration, callback) => {
      Toast.success(message, duration, callback)
    }

    renderFailToast = (message, duration, callback) => {
      Toast.fail(message, duration, callback)
    }

    render () {
      return (
        <ToastComponent />
      )
    }
  }

  /**
     * Declare Container
     */
  const mapStateToProps = (state) => {
    return {

    }
  }
  const mapDispatchToProps = (dispatch) => {
    return {

    }
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(injectIntl(_Toast_))
}

export default withToast



// WEBPACK FOOTER //
// ./src/components/hoc/Toast.js